<div class="modal-header">
  <h5 class="modal-title">Skicka supportfråga</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <p>
        En hel del frågeställningar runt hur Klubbavgift fungerar hittar du på
        <a href="https://support.klubbavgift.se" target="_blank">https://support.klubbavgift.se</a>. Hittar du inte det du söker
        där är du givetvis välkommen att skicka en fråga via formuläret nedan.
      </p>
      <p>
        Vi tar tacksamt emot rapporter av eventuella fel eller brister eller dina förbättringsförslag, oavsett om det gäller ett
        stavfel eller önskan om en helt ny funktion.<br />
        Information om eventuell organisation eller aktivitet inkluderas automatiskt.
      </p>

      <p>
        Om du önskar går det också bra att kontakta oss via
        <a href="https://www.facebook.com/klubbavgift.se" target="_blank">Facebook</a>,
        <a href="https://www.instagram.com/klubbavgift.se/" target="_blank">Instagram</a>,
        <a href="https://www.linkedin.com/company/klubbavgift" target="_blank">LinkedIn</a>
      </p>

      <div class="form-floating">
        <textarea
          class="form-control"
          [(ngModel)]="body"
          placeholder="Beskriv ditt ärende här"
          style="height: 200px"
          id="body"></textarea>
        <label for="body">Beskriv ditt ärende här</label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="isSending" (click)="send()">
    <span *ngIf="isSending">
      <span class="material-icons spin align-middle">sync</span>
      <span class="align-middle">Skickar...</span>
    </span>
    <span *ngIf="!isSending"> Skicka</span>
  </button>
  <button type="button" [disabled]="isSending" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Avbryt</button>
</div>
